/**
    订单评价--（就是对商家店铺的评价）
**/
<template>
        <div style="width: 1200px; margin: auto">
            <!-- 面包屑导航 -->
            <el-breadcrumb
                class="breakcrumbHeader"
                separator-class="el-icon-arrow-right"
                >
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/myOrderRight' }">我的订单</el-breadcrumb-item>
                <el-breadcrumb-item>{{$route.query.orderNumber}}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="aooraisalStatusBox" v-if="goodsList.status==5">
                <span>订单已评价！</span>
            </div>
            <div class="evaluationContent">
                <el-row :gutter="20">
                    <el-col :span="8">
                         <div class="wholeInfoBox">
                             <div style="text-align: center;">
                                <el-image :src="goodsList.bxunyouMerchant.logo?goodsList.bxunyouMerchant.logo:require('@/assets/img/store2.png')">
                                    <div slot="error" class="image-slot">
                                        <i class="el-icon-picture-outline"></i>
                                    </div>
                                </el-image>
                                <div class="goodsText">
                                    <router-link :to="`/shopStore?storeId=${goodsList.bxunyouMerchant.bxmId}`"><p  class="OneLineDisplay">{{goodsList.bxunyouMerchant.name}}</p></router-link>                                    
                                    <!-- <p class="OneLineDisplay">{{goodsList.bxyCommodityList[0].evaluationCount||0}}人评价</p>  -->
                                </div>
                            </div>                            
                        </div> 
                    </el-col>
                    <el-col :span="16">
                        <el-form ref="formLabelAlign" :rules="rules" :model="formLabelAlign">                            
                            <el-form-item prop="values" label="描述相符：">
                                 <el-rate
                                     class="rateBox"
                                     v-model="formLabelAlign.values">
                                 </el-rate>
                            </el-form-item>
                            <el-form-item prop="serviceValues" label="服务态度：">
                                 <el-rate
                                     class="rateBox"
                                     v-model="formLabelAlign.serviceValues">
                                 </el-rate>
                            </el-form-item>
                            <el-form-item prop="shipValues" label="发货速度：">
                                 <el-rate
                                     class="rateBox"
                                     v-model="formLabelAlign.shipValues">
                                 </el-rate>
                            </el-form-item>
                            <el-form-item >
                                <el-image class='evaluationImg' v-if="formLabelAlign.images?true:false" :src='formLabelAlign.images'></el-image>
                            </el-form-item>
                            <el-form-item prop="textarea">
                                <el-input
                                    class="textareaBox"
                                    type="textarea"
                                    :disabled="goodsList.status==5"
                                    :autosize="{ minRows: 2, maxRows: 4}"
                                    placeholder="外形如何，品质如何，好用吗，写点您真实的使用感受吧"
                                    v-model="formLabelAlign.textarea">
                                </el-input>
                            </el-form-item>
                            <div class="opreatContent">
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <div>
                                            如何写高质量的评价？
                                        </div>
                                        <div>
                                           <p class="howToWrite">感受如何：记录下开箱时的感受。</p> 
                                           <p class="howToWrite">产品如何：写点有理有据的产品分析。</p> 
                                           <p class="howToWrite">上传图片：放几张优雅的产品照片。</p> 
                                           <p class="howToWrite">提点建议：说说你的改进建议和好点子。</p> 
                                        </div>
                                    </el-col>
                                    <el-col :span="12" class="buttonGrop" v-if="goodsList.status!=5">
                                        <el-form-item label="">
                                            <el-button v-if="formLabelAlign.images?false:true" @click="addDialogVisible = true">添加图片</el-button>
                                            <el-button type="primary" class="buttonBgd" @click="finishUpload">发表评价</el-button>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-form>
                    </el-col>
                </el-row>
            </div>
            <!-- 上传图片 -->
              <el-dialog
                    class="addCartBox"
                    :close-on-click-modal='false'
                    :visible.sync="addDialogVisible"
                    width="30%"
                    title="上传图片"
                    >
                    <el-form ref="ruleForm" :rules="rules" :model="ruleForm">
                            <!-- <el-form-item label="网络图片" prop="textarea">
                                <el-input
                                    class="textareaBox"
                                    type="text"
                                    placeholder="请填入网络图片地址"
                                    v-model="ruleForm.netAddress">
                                </el-input>
                            </el-form-item> -->
                            <el-form-item label="本地图片" prop="localImg" class="myproof">
                                <el-upload
                                        name="files"
                                        class="avatar-uploader"
                                        :action="`${$baseUrl}/custom/xunyou/api/common/upload`"
                                        :show-file-list="false"
                                        :on-success="handleAvatarSuccess"
                                        :before-upload="beforeAvatarUpload">
                                        <img v-if="ruleForm.localImg" :src="formLabelAlign.images" class="avatar">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </el-form-item>
                            <el-form-item style="text-align:right" label="">
                                <el-button @click="cancleUoload">取消</el-button>
                                <el-button type="primary" class="buttonBgd" @click="uploadImg">上传完成</el-button>
                            </el-form-item>
                        </el-form>
                    </el-dialog>
        </div>
</template>
<script>
import { postComment,showorderList } from "@/api/xunyou";
export default {
  data() {
    return {
        userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
        addDialogVisible:false,
        urlImg:'',
        formLabelAlign:{
            values: 5,
            serviceValues: 5,
            shipValues: 5,
            textarea:'',
            images:'',   //图片            
            // oid:'', //订单ID
            // orderNumber:'',//订单号
            // goodId:'',   //商品ID
            // bxmId:'',   //店铺ID
            // uid:'',   //用户ID
            // images:'',   //图片
            // isAnonymous:'',   //匿名评价，非必填，默认匿名：0
            // matchScore:'',   //描述相符评分，非必填，默认0分
            // serviceScore:'',   //服务态度评分，非必填，默认0分
            // speedScore:'',   //发货速度评分，非必填，默认0分



        },
         ruleForm: {
             localImg:'',
             netAddress:'',
        },
        goodsList:{},
         rules: {
            localImg:[{ required: true, message: "不能为空,请上传图片", trigger: ["blur", "change"] },], 
             values: [
               { required: true, message: '请评分', trigger: 'blur' },
             ],
             serviceValues: [
               { required: true, message: '请评分', trigger: 'blur' },
             ],
             shipValues: [
               { required: true, message: '请评分', trigger: 'blur' },
             ],
             textarea: [
               { required: true,
                message: '请输入',
                trigger: 'blur',
                // validator:(rule, value, callback) => {
                //      if (value.length<10) {                      
                //        callback(new Error('至少输入10个字'));
                //      }else{
                //        callback();
                //      }
                //    } 
                }
             ]
        }
        
    };
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
      this.getOrderDetail()
    //   if(){
    //       this.orderNumber = orderNumber
    //   } this.$route.query.type
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取订单
    getOrderDetail(){
        showorderList({
            orderNumber:this.$route.query.orderNumber,					
			muid: this.userInfo.userId
        })
              .then((res) => {
                  if (res.code == 0) {
                      this.goodsList = res.rows[0]
                  }else{
                    this.$message.error(res.msg);
                  }
              })
              .catch((err) => {
                this.loading = false;
                this.$message.error("评论失败，请稍后再试！");
              });
    },

    //   发表评价  (评价完还要掉改商品评论详情接口)
     finishUpload() {     
      this.$refs.formLabelAlign.validate(valid => {
        if (valid) {
            const req = {
                type:1,//1.店铺评级，2.商品评价
                oid:this.goodsList.oid, // 
				orderNumber:this.$route.query.orderNumber,
				goodId:this.goodsList.bxyCommodityList[0].id, // 商品ID
				content:this.formLabelAlign.textarea, // 评价内容
				bxmId: this.goodsList.bxmId, // 店铺ID
				uid: this.userInfo.userId, // 用户id
				images:this.formLabelAlign.images.toString(), // 图片，非必填
                matchScore:this.formLabelAlign.values,//描述相符评分，非必填，默认0分
                serviceScore:this.formLabelAlign.serviceValues, //serviceScore
                speedScore:this.formLabelAlign.shipValues, //发货速度评分
                // starLevel:'', //starLevel

            }
          postComment(req)
              .then((res) => {
                  if (res.code == 0) {
                      this.getOrderDetail()
                      this.$message({
                          type: 'success',
                          message: '评论成功!'
                      });
                      this.$router.push('/myOrderRight')
                  }else{
                    this.$message.error(res.msg);
                  }
              })
              .catch((err) => {
                this.loading = false;
                this.$message.error("评论失败，请稍后再试！");
              });
        } else {          
          return false
        }
      })
    },
     //   上传图片
     uploadImg() {     
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
            this.addDialogVisible = false
        } else {          
          return false
        }
      })
    },

    // 取消上传
    cancleUoload(){
        this.formLabelAlign.images = ''// 用来图片预览的
        this.ruleForm.localImg =''
        this.addDialogVisible = false
    },

    //   支付凭证上传
    handleAvatarSuccess(res, file) {
        console.log(res,file.raw,URL.createObjectURL(file.raw))
            // this.urlImg = URL.createObjectURL(file.raw) // 用来图片预览的
            this.formLabelAlign.images = res.url // 用来图片预览的
            this.ruleForm.localImg =URL.createObjectURL(file.raw);
            this.payForImg = res.url;
            // this.sizeForm.businessLicense =URL.createObjectURL(file.raw). substring(URL.createObjectURL(file.raw).lastIndexOf("/"));
        },
        beforeAvatarUpload(file) {
            // const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;

            // if (!isJPG) {
            // this.$message.error('上传头像图片只能是 JPG 格式!');
            // }
            if (!isLt2M) {
            this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            // return isJPG && isLt2M;
            return isLt2M;
        },
  },
};
</script>

<style scoped lang="less">
.aooraisalStatusBox {
    background-color: #fcf8e3;
    color: #8a6d3b;
    padding: 0 20px;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 3px;
    padding: 15px;
    border: 1px solid #faebcc;
    border-radius: 4px;
}
.evaluationContent{
        padding: 60px;
        font-size: 14px;
        background: white;
        /deep/.el-form-item__label{
            line-height: inherit;
        }
    .wholeInfoBox{
                width: 80%;
                height: auto;
                margin-bottom: 50px;
                
                .el-image{
                    width: 200px;
                    height: 200px;
                }
                .goodsText {
                    text-align: center;
                    margin-bottom: 4px;
                }
                 .mark{
                    display: none;
                    font-size: 14px;
                    background: rgba(255, 255, 255, 0.8);
                    position: relative;
                    .redeemNow {
                            background: #78b942;
                            padding: 6px;
                            text-align: center;
                            color: white;
                            cursor: pointer;
                            position: absolute;
                            left: 50%;
                            transform: translate(-50%);
                            border-radius: 6px;
                    }
                    .redeemNow:hover{
                        background-color: rgba(34, 34, 34, 0.85);
                    }
                }
            }
            .evaluationImg{
                width: 150px;
                height: auto;
            }
             .textareaBox{
                     margin: 20px 0;
                }
            .rateBox{

            }
            .opreatContent{
                // padding: 20px 0;
               .howToWrite{
                   font-size: 12px;
                   color: #757575;
                   margin: 6px 0px;
               }
                .buttonGrop{
                    text-align:right;
                }

            }
                 button.el-button.buttonBgd.el-button--primary {
                       background-color: #78b942;
                       border-color: #78b942;
                    //    font-size: 18px;
                    //    margin: 20px 0;
                   }
}
                .addCartBox{
                    /deep/.avatar-uploader {
                              padding-bottom: 15px;
                              box-sizing: border-box;
                          }
                      /deep/.el-upload.el-upload--text {
                              border: 1px solid #ccc;
                          }
                  
                      .avatar-uploader .el-upload {
                          border: 1px dashed #d9d9d9;
                          border-radius: 6px;
                          cursor: pointer;
                          position: relative;
                          overflow: hidden;
                      }
                      .avatar-uploader .el-upload:hover {
                          border-color: #409EFF;
                      }
                      .avatar-uploader-icon {
                          font-size: 28px;
                          color: #8c939d;
                          width: 178px;
                          height: 178px;
                          line-height: 178px;
                          text-align: center;
                      }
                      .avatar {
                          width: 160px;
                          height: 160px;
                          display: block;
                      }
                      button.el-button.buttonBgd.el-button--primary {
                       background-color: #78b942;
                       border-color: #78b942;
                    //    font-size: 18px;
                    //    margin: 20px 0;
                   }
    
                }
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/myOrder/evaluationePage/orderAppraisal.vue